var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMzc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FFAA05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45619 6.50644V7.55438H10.7016L10.1391 8.20012H9.30263V9.01181H10.1728L9.74644 9.65756H9.30263V11.3136L8.58656 12.2901V9.65756H7.59656L8.14275 9.01181H8.58656V8.20012H7.18762L7.75012 7.55438H8.58656V6.46875C8.17425 6.02269 7.60556 5.79938 6.8805 5.79938C5.49 5.79938 4.38975 7.28156 4.38975 8.75531C4.38975 9.73744 4.61475 10.5711 5.06362 11.2556L4.28738 12.1579C3.67931 11.2568 3.375 10.2274 3.375 9.06975C3.375 6.52781 5.56312 5.0625 7.11056 5.0625C8.05781 5.0625 8.78344 5.45962 9.28744 6.25331C10.2516 5.59181 11.2376 5.26106 12.2456 5.26106C13.7891 5.26106 14.625 7.14544 14.625 8.94544C14.625 11.3406 13.0129 12.2653 12.4245 12.3733C12.4029 12.3773 12.3806 12.3751 12.3602 12.3669C12.3398 12.3587 12.3221 12.345 12.3092 12.3272C12.3005 12.3152 12.2944 12.3016 12.2912 12.2872C12.2879 12.2728 12.2876 12.2579 12.2903 12.2434C12.293 12.2289 12.2986 12.2151 12.3068 12.2028C12.3149 12.1905 12.3255 12.18 12.3379 12.1719C13.2486 11.5599 13.7036 10.6223 13.7036 9.35944C13.7036 6.60262 12.2878 5.96475 11.2472 5.96475C10.6096 5.96298 9.98595 6.1516 9.45619 6.50644Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMzc);
export default __webpack_public_path__ + "static/media/mzc.c6af1d48745c36e289cf9977b1787c79.svg";
export { ForwardRef as ReactComponent };